import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../UI/Modal/Modal'
import cl from '../../UI/Modal/Modal.module.css'
import Client from "../../../assets/Icon/User";
import fnc from './Finances.module.css'
import { AppContext } from '../../../providers/appProvider';
import tbl from '../../../assets/Style/Table.module.css' 
import AutowiniInvoice from './Invoice/AutowiniInvoice';
import ClientPriceForm from './Update/ClientPriceForm/ClientPriceForm';
import { baseFileURL } from '../../../Api';
import { useTranslation } from 'react-i18next';

const ClientPriceModal = ({ carService, defaultCar, setDefaultCar, onSave }) => {
    const { t } = useTranslation();
    const formatDate = (dateString) => {

        const newAtDate = new Date(dateString);

        const months = [
            "იან",
            "თებ",
            "მარ",
            "აპრ",
            "მაი",
            "ივნ",
            "ივლ",
            "აგვ",
            "სექ",
            "ოქტ",
            "ნოე",
            "დეკ"
        ];

        const day = newAtDate.getDate();
        const month = months[newAtDate.getMonth()];
        const year = newAtDate.getFullYear();
        const hours = String(newAtDate.getHours()).padStart(2, '0');
        const minutes = String(newAtDate.getMinutes()).padStart(2, '0');

        return `${day} ${month} ${year} ${hours}:${minutes}`;

    };
   

    const prices = carService.calculatePrice(defaultCar); 

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [car, setCar] = useState(defaultCar);
    const { appState, app } = useContext(AppContext);
    const [pricelogs, setPricelog] = useState([]);
 
  

    useEffect(() => {
        setCar(defaultCar)
        
        if(defaultCar?.dealer?.id != null && defaultCar.dealer.id > 0 ){
            setCar({
                ...defaultCar, 
                dealer_id: defaultCar.dealer.id,
            }) 
        }

        
    }, [defaultCar]);

    const refreshData = () => { 
        carService.fetchClientPrices(car.id)
            .then(price => {
                setPricelog(price)
            })
            .catch(error => {
                console.error(error);
            });
    }

    useEffect(() => {
        if (isModalOpen) {
            refreshData()
        }


        


    }, [isModalOpen]);

 
    const onUpdateClick = (event) => { 
        carService.updateClientPrice(car) 
        setIsModalOpen(false)
        onSave()
    };
 

    const sumClientPrice = (jsonClientPrice) => {

        const price = JSON.parse(jsonClientPrice); 
        const total = price.client_price_car +
            price.client_price_transport +
            price.client_price_internal +
            price.client_price_document +
            price.client_price_insurance +
            price.client_price_dealer +
            price.client_price_dealer_transport +
            price.client_price_penalty +
            price.client_price_transfer_fee +
            price.client_price_another;
        return total 
    }

    const parseJson = (caroldinfo) => { 
        const carold = JSON.parse(caroldinfo);
        return carold 
    }
 

    return (
        <div>

 

            <div className={fnc.finance} style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div onClick={() => {
                    if (5 !== defaultCar.website.id) {
                        setIsModalOpen(true)
                    }

                }
                } className={fnc.financeBox + ' ' + fnc.blueFin}  >
                    <div className={fnc.financeDesc + ' nonetable'}>
                        {t('Client')}
                    </div>

                    <div className={fnc.financeValue}> 
                        
                        {(5 === defaultCar.website.id) ? 
                            (defaultCar.client_deposit !== 0 ? defaultCar.client_deposit : ' ')
                            :
                            (defaultCar.total_client_price !== 0 ? defaultCar.total_client_price : ' ')
                        }
                    </div>
                </div>


                {(car.client_price_fund * car.client_percent_fund) / 100 > 0 ?
                    car.fund_accept == 1 ?
                        <AutowiniInvoice secondBtn={false} discountAccept={car.discount_accept} carItem={defaultCar} websiteItem={car.website} clientItem={car.client} />
                    :
                        ''
                    :
                    <AutowiniInvoice secondBtn={false} discountAccept={car.discount_accept} carItem={defaultCar} websiteItem={car.website} clientItem={car.client} />
                } 


 
                 
            </div>

 

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={fnc.iconHead + ' ' + fnc.blueFin}> <Client /></span>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>  
                            <div style={{ lineHeight: 1, fontSize: 14, fontWeight: 600, marginTop: 3 }}> {car.id}{defaultCar.lot !== undefined ? '/' + defaultCar.lot : '' }</div>
                        </div>
                    </h3>

                </div>


                <div>
  
                    <ClientPriceForm newCar={car} setNewCar={setDefaultCar} isAdd={true} prices={prices} ></ClientPriceForm>
  
                    <span style={{ fontSize: '14px', display: 'flex',  justifyContent: 'flex-end', width: '100%', marginBottom: '10px',  marginTop: '10px' }} >
    
                        {(car.client_price_fund * car.client_percent_fund) / 100 > 0 ?
                            car.fund_accept == 1 ?
                                <AutowiniInvoice secondBtn={false}  discountAccept={car.discount_accept} carItem={defaultCar} websiteItem={car.website} clientItem={car.client} />
                            :
                                ''
                            :
                            <AutowiniInvoice secondBtn={false}  discountAccept={car.discount_accept} carItem={defaultCar} websiteItem={car.website} clientItem={car.client} />
                        } 
                    </span>
 

                    {app.hasPermission("CLIENT_PRICE_EDIT") &&
                        <div className={fnc.flexend} >

                            <button type="submit" onClick={onUpdateClick} className={fnc.btnPrimary} >შენახვა</button>

                        </div>
                    }

                </div>


                <div style={{ position: 'relative', display: 'block', minHeight: 'unset', marginTop: '20px', }}>

                    <div className={tbl.table} style={{ position: 'relative', display: 'block', minHeight: 'unset' }}>
                        <table>
                            <thead>
                                <tr>
                                    <th className={cl.id} >#</th>
                                    <th>თარიღი</th>
                                    <th>თანხა</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {pricelogs ? (
                                    pricelogs.map((pricelogs) =>
                                        <tr>
                                            <td>{pricelogs.id}</td>
                                            <td>{formatDate(pricelogs.created_at)}</td>
                                            <td style={{ fontWeight: 'bold', color: 'var(--text-color)' }}>{sumClientPrice(pricelogs.old)}</td>
                                            <td> 
                                               
 
                                                {(car.client_price_fund * car.client_percent_fund) / 100 > 0 ?
                                                    car.fund_accept == 1 ?
                                                        <AutowiniInvoice secondBtn={true} discountAccept={car.discount_accept} carItem={parseJson(pricelogs.old)} websiteItem={defaultCar.website} clientItem={defaultCar.client } />
                                                    :
                                                        ''
                                                    :
                                                    <AutowiniInvoice secondBtn={true} discountAccept={car.discount_accept} carItem={parseJson(pricelogs.old) } websiteItem={defaultCar.website} clientItem={defaultCar.client } />
                                                }
 
                                            </td>
                                        </tr>
                                    )
                                ) : (
                                    <tr>იტვირთება...</tr>
                                )}
                            </tbody>
                        </table>

                    </div>

                </div>


            </Modal>
        </div>
    );
};

export default ClientPriceModal;